import './index.scss';
import { defineComponent, h } from 'vue';
import { Modal } from '@phi/components';
import {
    floating_toolbar_buttons,
    floating_toolbar_position,
    showing_floating_toolbar,
} from '../../state';
import { hide_floating_toolbar, show_floating_toolbar } from '@features/floating-toolbar/util';
import { px } from '@phi/util/css';

export const FloatingToolbar = defineComponent({
    setup() {
        return () => h(Modal, {
            show: showing_floating_toolbar.value,
            'onUpdate:show': (x) => {
                if (x) show_floating_toolbar();
                else hide_floating_toolbar();
            },
            id: 'floatingtoolbar',
            backdrop: false,
            draggable: false,
            width: 'narrower',
            style: {
                transition: 'left var(--t-normal) ease, top var(--t-normal) ease',
                position: 'absolute',
                left: px(floating_toolbar_position.value.left),
                top: px(floating_toolbar_position.value.top),
            },
        }, {
            body: () => h('div', { class: 'buttons' }, floating_toolbar_buttons.value),
        });
    }
});
